import { domain_vizr } from "../../../redux/constants/constants";

export const SET_NTFS_LOADER = "SET_NTFS_LOADER";
export const SET_ALL_FOLDERS_DATA = "SET_ALL_FOLDERS_DATA";
export const SET_FOLDER_CURRENT_PAGE = "SET_FOLDER_CURRENT_PAGE";
export const SET_FOLDER_CURRENT_SIZE = "SET_FOLDER_CURRENT_SIZE";
export const CLEAR_ALL_FOLDER_DATA = "CLEAR_ALL_FOLDER_DATA";
export const FETCH_ALL_FOLDERS_DATA = "FETCH_ALL_FOLDERS_DATA";
export const SET_TOTAL_FOLDER_COUNT = "SET_TOTAL_FOLDER_COUNT";
export const fetchAllFoldersAPI = (id, page, size) => {
  return `${domain_vizr}/tenant/dataMap/directoryPermission/${id}?page=${page}&size=${size}`
};
export const directoryDescription = "Enter the full path of the directories you want to monitor.";
export const directoryExample = "Ex: C:\\DataVision\\Example\\Shared"
export const processDescription = "Specify the process names to exclude from monitoring.";
export const processExample = "Ex: C:\\Program Files\\Windows Defender Advanced Threat Protection\\MsSense.exe";
export const ScanPathsDescription = "Enter the full paths you want to scan.";
export const ScanPathsExample = "Ex: C:\\DruvStar\\ai\\sampledata";
export const ExcludePatternsDescription = "Specify the patterns to exclude from scanning.";
export const ExcludePatternsExample = "Ex: **/.git/**, **/tmp/**";
export const ScanTimeDescription = "Specify the scan time range using 24-hour format (HH:MM).";
export const ScanTimeExample = "Ex: Start Time - 09:00, End Time - 18:00";
export const localEndPointDescription = "A logical name used to identify and organize a group of local endpoints."
export const cpuCapacityDescription = "Specify the maximum CPU utilization as a percentage."
export const cpuExample = "Ex: For 10%, enter 10."